import { defineComponent as o, openBlock as r, createBlock as a, withCtx as t, unref as l, createCommentVNode as c, createVNode as n } from "vue";
import { RevIllustration as m } from "@ds/components/Illustration";
import i from "../../../icons/generated/IconWarning.vue2.js";
import s from "./DocumentSmallAvatar.vue2.js";
import u from "./DocumentSmallBase.vue2.js";
const k = /* @__PURE__ */ o({
  name: "DocumentErrorSmall",
  __name: "DocumentErrorSmall",
  props: {
    name: {},
    url: {},
    errorMessage: {},
    thumbnail: { type: Boolean }
  },
  setup(e) {
    return (f, d) => (r(), a(u, {
      "button-attrs": {
        title: e.errorMessage,
        ...e.url && { href: e.url, target: "_blank" }
      },
      class: "border-static-danger-hi"
    }, {
      avatar: t(() => [
        n(s, {
          class: "pointer-events-none",
          interactive: !1,
          label: e.errorMessage
        }, {
          default: t(() => [
            n(l(i), {
              class: "text-static-danger-hi",
              size: "16"
            })
          ]),
          _: 1
        }, 8, ["label"])
      ]),
      default: t(() => [
        e.url ? (r(), a(l(m), {
          key: 0,
          alt: "",
          height: 62,
          "image-class-names": "h-[calc(4rem-2px)] w-64 object-cover object-center",
          src: e.url,
          title: e.name,
          width: 64
        }, null, 8, ["src", "title"])) : c("", !0)
      ]),
      _: 1
    }, 8, ["button-attrs"]));
  }
});
export {
  k as default
};
